import { IGenericLoginsRow } from "./GenericLogins.types";
import { StyledTd, StyledTr } from "../../../../styled";
import { useNavigate } from "react-router-dom";
import { unifyDate } from "../../../../utils";

interface Props extends IGenericLoginsRow {}
const GenericLoginsRow = ({ name, datecreated, email, genid }: Props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`./edit-login/${genid}`);
  };
  return (
    <StyledTr onClick={handleClick} hover pointer>
      <StyledTd>{name}</StyledTd>
      <StyledTd>{email}</StyledTd>
      <StyledTd>{unifyDate(datecreated)}</StyledTd>
    </StyledTr>
  );
};
export default GenericLoginsRow;
